import { useEffect } from 'react';
import { initializeChat } from '@/utils/chatService';

/**
 * ChatWidget Component
 * This component initializes and manages the LiveChat widget.
 * The script is loaded via /assets/js/chat-script.js in index.html.
 */
const ChatWidget = () => {
  useEffect(() => {
    // Initialize chat when component mounts
    initializeChat();
  }, []);

  return (
    <>
      {/* LiveChat widget is injected by /assets/js/chat-script.js */}
      <div id="chat-widget-container"></div>
    </>
  );
};

export default ChatWidget;
